import { Components } from '../../../styles';
import { COLOR_DEFAULT, COLOR_PRIMARY, COLOR_SECONDARY, VARIANT } from './button';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const buttonGroupTheme = {
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        '.MuiButtonBase-root': {
          '&.MuiButtonGroup-firstButton': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
          },
          '&.MuiButtonGroup-lastButton': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
          },
          '&.MuiButtonGroup-middleButton': {
            borderRadius: 0
          }
        },

        '.MuiButtonGroup-grouped[aria-current="true"]:after': {
          backdropFilter: 'none'
        },

        variants: [
          {
            props: { variant: 'contained' },
            style: {
              '.MuiButtonGroup-grouped': VARIANT.contained
            }
          },
          {
            props: { variant: 'outlined' },
            style: {
              '.MuiButtonGroup-grouped': VARIANT.outlined
            }
          },
          {
            props: { color: 'default' },
            style: {
              '.MuiButtonGroup-grouped[aria-current="true"]': {
                backgroundColor: tokens.colorSecondaryContainer
              },
              '.MuiButtonGroup-firstButton, .MuiButtonGroup-middleButton': {
                borderColor: tokens.colorOutline
              }
            }
          },
          {
            props: { color: 'default', variant: 'outlined' },
            style: {
              '.MuiButtonGroup-grouped': {
                borderColor: tokens.colorOutline,
                '&[aria-current="true"]': {
                  border: `1px solid ${tokens.colorOutline}`
                }
              }
            }
          },
          {
            props: { color: 'default', variant: 'contained' },
            style: {
              '.MuiButtonGroup-grouped': COLOR_DEFAULT.contained
            }
          },
          {
            props: { color: 'primary' },
            style: {
              '.MuiButtonGroup-grouped': { ...COLOR_PRIMARY.default, borderColor: tokens.colorOutline },
              '.MuiButtonGroup-grouped[aria-current="true"]': COLOR_PRIMARY.contained
            }
          },
          {
            props: { color: 'primary', variant: 'contained' },
            style: {
              '.MuiButtonGroup-grouped': {
                ...COLOR_PRIMARY.contained,
                borderColor: tokens.colorOnPrimaryContainer
              }
            }
          },
          {
            props: { color: 'primary', variant: 'outlined' },
            style: {
              '.MuiButtonGroup-grouped': COLOR_PRIMARY.outlined
            }
          },
          {
            props: { color: 'secondary' },
            style: {
              '.MuiButtonGroup-grouped': {
                ...COLOR_SECONDARY.default,
                borderColor: tokens.colorOutline
              },
              '.MuiButtonGroup-grouped[aria-current="true"]': COLOR_SECONDARY.contained
            }
          },
          {
            props: { color: 'secondary', variant: 'contained' },
            style: {
              '.MuiButtonGroup-grouped': {
                ...COLOR_SECONDARY.contained,
                borderColor: tokens.colorAlert // @migrate tokens v5 `#8f1107`
              }
            }
          },
          {
            props: { color: 'secondary', variant: 'outlined' },
            style: {
              '.MuiButtonGroup-grouped': COLOR_SECONDARY.outlined
            }
          }
        ]
      }
    }
  }
} satisfies Components;
